import { FC, HTMLAttributes, useState } from "react";
import { Typography } from "../../components/core/Typography/Typography";
import { TypographyVariant } from "../../constants/typography";
import AppBar from "../../components/common/AppBar/AppBar";
import { Icon } from "../../components/core/Icon/Icon";
import { SubscriptionCard } from "../../components/common/SubscriptionCard";
import { ActiveIframe } from "../../components/common/GameFeed/ActiveIframe";
import { HistoryGaming } from "../../models/historyGaming";
import { Time } from "../../models/time";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useStyles } from "./Subsciption.style";
import { useTgpSubscriptions } from "../../hooks/useTgpSubscriptions";
import { useAppSelector } from "../../components/hooks";
import { shouldRedirectExternal } from "../../models/theme";
import { resolveServiceId } from "../../constants/services";
import { useProductByTenants } from "../../hooks/useProductByTenants";

const Subscription: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { subscriptions, refetch, error } = useTgpSubscriptions();
  const { getProductIcon }  = useProductByTenants();
  const { theme } = useAppSelector((state) => state.theme);
  const [showIframe, setShowIframe] = useState(false);
  const [iframeUrl, setIframeUrl] = useState<string | null>(null);
  const [activeSubscriptionId, setActiveSubscriptionId] = useState("");

  if (error) {
    console.error("TGP subscriptions error:", error);
  }

  const handleUnsubscribe = (redirectUrl?: string | null) => {
    if (!redirectUrl) return;

    if (shouldRedirectExternal(theme)) {
      window.location.href = redirectUrl;
      return;
    }

    setActiveSubscriptionId("subscription-management");
    setIframeUrl(redirectUrl);
    setShowIframe(true);
  };

  const closeIframeAndRefreshSubscriptions = async () => {
    setShowIframe(false);
    setIframeUrl(null);
    try {
      await refetch();
    } catch (error) {
      console.error("TGP subscriptions refetch error:", error);
    }
  };

  return (
    <>
      {!showIframe && (
        <div className={classes.root}>
          <AppBar
            leftItems={
              <Icon
                name="icon-bold-arrow-left-3"
                onClick={() => HistoryGaming.back(navigate)}
              />
            }
            centerItems={
              <Typography variant={TypographyVariant.BodyB4Medium}>
                {t("common_Subscription")}
              </Typography>
            }
          />
          <div className={classes.container}>
            {subscriptions.map((subscription) => {
              const productId =
                subscription.product?.id ?? subscription.productId;
              const serviceId = resolveServiceId(productId);
              const title = subscription.product?.title ?? serviceId;
              const icon =
                subscription.product?.icon ??
                getProductIcon(serviceId) ??
                "";

              return (
                <SubscriptionCard
                  key={subscription.product?.id || subscription.productId}
                  title={title}
                  billingDate={
                    subscription.renewalDate
                      ? Time.formatDate(
                          subscription.renewalDate,
                          "mmm dd, yyyy",
                        )
                      : "N/A"
                  }
                  logo={icon}
                  onUnsubscribe={() =>
                    handleUnsubscribe(subscription.redirectUrl)
                  }
                />
              );
            })}
          </div>
        </div>
      )}
      {showIframe && iframeUrl && (
        <ActiveIframe
          iframeUrl={iframeUrl}
          feedId={activeSubscriptionId}
          title="subscription-iframe"
          onCloseIframe={closeIframeAndRefreshSubscriptions}
        />
      )}
    </>
  );
};

export default Subscription;
